import { Action } from '../../../actions';
import { BulkReplacementRadio } from '../../../components/BulkReplacementModeChooser/BulkReplacementModeChooser';
import { GroupsEditMassActions, GroupsEditMassActionsState, MassActionId } from '../../../typings/groupsEditState';
import { State } from '../../../typings/state';

import { groupsEditMinusPhrasesMassActions } from './groups-edit-minus-phrase-mass-actions';

const groupsEditMassActionInitialState: GroupsEditMassActions = {
    visibleModalActions: {
        minusPhraseModal: false
    },
    data: {
        minusPhrasesRadio: BulkReplacementRadio.REPLACE
    }
};

export const groupsEditMassActionsInitialState = {
    [MassActionId.groupsEdit]: groupsEditMassActionInitialState
};

export const groupsEditMassActions = (
    state: GroupsEditMassActionsState = groupsEditMassActionsInitialState,
    action: Action,
    fullState: State
): GroupsEditMassActionsState => {
    state = groupsEditMinusPhrasesMassActions(state, action, fullState);

    return state;
};
